"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Logger", {
    enumerable: true,
    get: function() {
        return Logger;
    }
});
const _LogLevel = require("./interfaces/LogLevel.js");
const _readline = require("readline");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class Logger {
    log(level, msg, data) {
        const entry = {
            timestamp: Date.now(),
            level,
            msg,
            data
        };
        for (const reporter of this.reporters){
            reporter.log(entry);
        }
    }
    info(msg, data) {
        this.log(_LogLevel.LogLevel.info, msg, data);
    }
    warn(msg, data) {
        this.log(_LogLevel.LogLevel.warn, msg, data);
    }
    error(msg, data) {
        this.log(_LogLevel.LogLevel.error, msg, data);
    }
    verbose(msg, data) {
        this.log(_LogLevel.LogLevel.verbose, msg, data);
    }
    silly(msg, data) {
        this.log(_LogLevel.LogLevel.silly, msg, data);
    }
    stream(level, input, data) {
        const readline = (0, _readline.createInterface)({
            input,
            crlfDelay: Infinity,
            terminal: false
        });
        const lineLogger = (line)=>{
            this.log(level, line, data);
        };
        readline.on("line", lineLogger);
        return ()=>{
            readline.off("line", lineLogger);
            readline.close();
        };
    }
    addReporter(reporter) {
        this.reporters.push(reporter);
    }
    constructor(){
        _define_property(this, "reporters", []);
    }
}
